export enum ApiExternal {
  LOCAL_STORAGE_KEY = 'api_external_v1_token'
}
